var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLearnMoreTreeLine(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 204.727,
    height: 607.602,
    viewBox: "0 0 204.727 607.602",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Learn_More_Line_Tree",
    "data-name": "Learn More Line Tree",
    transform: "translate(-2915.529 -765.61)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1085",
    "data-name": "Path 1085",
    d: "M131.837,213.562V400.505h-142V821.163",
    transform: "translate(2929.692 552.049)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 8
  }), /*#__PURE__*/React.createElement("g", {
    id: "plant",
    transform: "translate(3005.014 782.421)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_85",
    "data-name": "Group 85",
    transform: "translate(0 21.579)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_84",
    "data-name": "Group 84",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1128",
    "data-name": "Path 1128",
    d: "M46.331,32.362C36.263,22.7,16.562,21.579,2.616,21.579A2.567,2.567,0,0,0,0,24.091C0,37.482,1.162,56.4,11.23,66.068c4.249,4.08,10.764,5.9,17.221,5.9,7.017,0,13.972-2.156,17.881-5.909C53.83,58.862,55.206,40.879,46.331,32.362Zm-3.7,30.153c-5.6,5.371-21.146,6.291-27.7,0-8.127-7.8-9.534-23.656-9.686-35.9,12.747.146,29.257,1.5,37.383,9.3C49.183,42.21,48.226,57.144,42.632,62.515Z",
    transform: "translate(0 -21.579)",
    fill: "#76c8ae"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_87",
    "data-name": "Group 87",
    transform: "translate(62.76 31.518)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_86",
    "data-name": "Group 86",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1129",
    "data-name": "Path 1129",
    d: "M305.728,63.776c-13.945,0-33.647,1.115-43.715,10.783-8.875,8.517-7.5,26.5,0,33.7,3.909,3.749,10.858,5.9,17.875,5.9,6.457,0,12.967-1.819,17.226-5.9,10.063-9.667,11.23-28.585,11.23-41.976A2.567,2.567,0,0,0,305.728,63.776ZM293.4,104.707c-6.551,6.291-22.1,5.371-27.7,0s-6.551-20.3,0-26.6c8.127-7.8,24.636-9.155,37.383-9.3C302.939,81.056,301.531,96.909,293.4,104.707Z",
    transform: "translate(-255.862 -63.776)",
    fill: "#76c8ae"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_89",
    "data-name": "Group 89",
    transform: "translate(20.93 41.682)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_88",
    "data-name": "Group 88",
    transform: "translate(1)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1130",
    "data-name": "Path 1130",
    d: "M158.128,118.511a2.887,2.887,0,0,0-3.689-1.111c-20.068,9.06-29.926,24.857-34.406,41.1-5.542-34.53-21.57-45.057-28.367-49.523a16.418,16.418,0,0,1-1.873-1.311,2.7,2.7,0,0,0-3.7,0,2.444,2.444,0,0,0,0,3.553,20.983,20.983,0,0,0,2.622,1.9c7.661,5.03,28.011,18.4,28.011,71.688a2.619,2.619,0,0,0,5.233.005c0-21.531,6.023-49.915,34.709-62.859,0,0,.424-.2.424-.2A2.286,2.286,0,0,0,158.128,118.511Z",
    transform: "translate(-85.328 -106.928)"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLearnMoreTreeLine);
export default __webpack_public_path__ + "static/media/learn-more-tree-line.d3d09b713be001d12cb3476547f99e0a.svg";
export { ForwardRef as ReactComponent };